import ImgContainer from "components/common/img";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { getFormattedContactNumber, hasPermission } from "utility/helpers";
import { CellText, StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";
import styled from "styled-components";

const PhotoFrame = styled.div`
  width: 50px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const otherColumns = ({ userImage, navigate, handleDeleteAction }) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "",
      selector: ({ photo }) => photo,
      grow: 0,
      minWidth: "80px",
      sortable: false,
      style: { paddingTop: "0.5rem", paddingBottom: "0.5rem" },
      cell: ({ photo }) => (
        <PhotoFrame>
          <ImgContainer
            alt="cong-image"
            src={photo || userImage}
            width="50px"
          />
        </PhotoFrame>
      ),
    },
    {
      name: "Full Name",
      selector: (row) => row?.fullName,
      identifier: "fullName",
      grow: 2,
      sortable: true,
      cell: ({ fullName }) => <CellText>{fullName}</CellText>,
    },
    {
      name: "Contact Info",
      selector: ({ contact }) => contact,
      identifier: "contact",
      grow: 2,
      sortable: true,
      cell: ({ contact }) => (
        <CellText>{getFormattedContactNumber(contact)}</CellText>
      ),
    },
    {
      name: "Action",
      selector: (row) => row?.id,
      sortable: false,
      width: "100px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row, index) => (
        <>
          {hasPermission("official-update") && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${index}`}
                onClick={() => {
                  navigate("/others", {
                    state: {
                      others: row,
                    },
                  });
                }}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`edit-row--${index}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("official-delete") && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${index}`}
                onClick={() => handleDeleteAction(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${index}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
  ];
};

export default otherColumns;
